/**
 * YearSelector - Dropdown for selecting report year
 * @module wellRegistrationTotals/components/molecules/YearSelector
 */

import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@material-ui/core";
import { YEAR_OPTIONS } from "../../constants";

/**
 * Year selection dropdown
 * @param {Object} props
 * @param {number} props.value - Currently selected year
 * @param {Function} props.onChange - Change handler
 */
const YearSelector = React.memo(({ value, onChange }) => (
  <Box width="200px">
    <FormControl fullWidth variant="outlined">
      <InputLabel>Select Year</InputLabel>
      <Select value={value} onChange={onChange} label="Select Year">
        {YEAR_OPTIONS.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
));

YearSelector.displayName = "YearSelector";

export default YearSelector;
